/* eslint-disable @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values,  @atlaskit/platform/no-module-level-eval */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { default as AtlasButton } from '@atlaskit/button';
import { fg } from '@atlaskit/platform-feature-flags';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Button = styled(AtlasButton)({
	minWidth: token('space.500', '40px'),
	width: token('space.500', '40px'),
	height: token('space.500', '40px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
	flexBasis: 'auto !important',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export const ConditionWrapper = styled.div({
	display: 'flex',
	gap: token('space.100', '8px'),
	alignItems: 'flex-end',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	'& > *, & > [data-ds--text-field--container]': {
		flex: fg('enable-merged-condition-filters') ? '0 0 25%' : '0 0 15%',
		maxWidth: fg('enable-merged-condition-filters') ? '25%' : '15%',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'& > div:last-of-type': {
		flex: 1,
		maxWidth: '100%',
	},
});
